export const APPLICATION_HUB_FETCHING = 'APPLICATION_HUB_FETCHING';
export const APPLICATION_HUB_FETCH_APPLICATION =
  'APPLICATION_HUB_FETCH_APPLICATION';
export const APPLICATION_HUB_FETCH_RELEASE_CATEGORY =
  'APPLICATION_HUB_FETCH_RELEASE_CATEGORY';
export const APPLICATION_HUB_FETCH_GRADES = 'APPLICATION_HUB_FETCH_GRADES';
export const APPLICATION_HUB_FETCH_ERROR = 'APPLICATION_HUB_FETCH_ERROR';
export const APPLICATION_HUB_UPDATE_HOH = 'APPLICATION_HUB_UPDATE_HOH';
export const APPLICATION_HUB_UPDATE_MEMBER = 'APPLICATION_HUB_UPDATE_MEMBER';
export const APPLICATION_HUB_UPDATE_STUDENT = 'APPLICATION_HUB_UPDATE_STUDENT';
export const APPLICATION_HUB_DELETE_MEMBER = 'APPLICATION_HUB_DELETE_MEMBER';
export const APPLICATION_HUB_DELETE_STUDENT = 'APPLICATION_HUB_DELETE_STUDENT';
export const APPLICATION_HUB_SET_UPDATED_APPLICATION =
  'APPLICATION_HUB_SET_UPDATED_APPLICATION';
export const APPLICATION_HUB_UPDATE_APPSUMMARY_FAMILYSIZE =
  'APPLICATION_HUB_UPDATE_APPSUMMARY_FAMILYSIZE';
export const APPLICATION_HUB_FETCH_UPDATED_APP =
  'APPLICATION_HUB_FETCH_CALCULATED_STATUS';
export const APPLICATION_HUB_APP_RECALCULATED =
  'APPLICATION_HUB_APP_RECALCULATED';
export const APPLICATION_HUB_FORCE_RECALCULATE =
  'APPLICATION_HUB_FORCE_RECALCULATE';
export const APPLICATION_HUB_CLEAR_CASE_INFO =
  'APPLICATION_HUB_CLEAR_CASE_INFO';
export const APPLICATION_HUB_CLEAR = 'APPLICATION_HUB_CLEAR';
export const APPLICATION_HUB_SUBMITTING = 'APPLICATION_HUB_SUBMITTING';
export const APPLICATION_HUB_SUBMIT_ERROR = 'APPLICATION_HUB_SUBMIT_ERROR';
export const APPLICATION_HUB_SUBMITTED = 'APPLICATION_HUB_SUBMITTED';
export const APPLICATION_HUB_REMOVE_INCOME = 'APPLICATION_HUB_REMOVE_INCOME';
export const APPLICATION_HUB_CLEAR_ERRORS = 'APPLICATION_HUB_CLEAR_ERRORS';
export const APPLICATION_HUB_CHANGE_EFFECTIVE_DATE =
  'APPLICATION_HUB_CHANGE_EFFECTIVE_DATE';
export const APPLICATION_HUB_CHANGE_APPLICATION_DATE =
  'APPLICATION_HUB_CHANGE_APPLICATION_DATE';
export const APPLICATION_HUB_REDIRECT = 'APPLICATION_HUB_REDIRECT';
export const APPLICATION_HUB_SET_IS_SECOND_REVIEW =
  'APPLICATION_HUB_SET_IS_SECOND_REVIEW';
export const APPLICATION_HUB_SET_ORIGINAL_STATUSES =
  'APPLICATION_HUB_SET_ORIGINAL_STATUSES';
export const APPLICATION_HUB_SET_SHOW_SECOND_REVIEW_STATUS_CHANGE_DIALOG =
  'APPLICATION_HUB_SET_SHOW_SECOND_REVIEW_STATUS_CHANGE_DIALOG';
export const APPLICATION_HUB_SET_HAS_STATUS_CHANGED =
  'APPLICATION_HUB_SET_HAS_STATUS_CHANGED';
export const APPLICATION_HUB_SET_SECOND_REVIEW_RESULT_RECORDED =
  'APPLICATION_HUB_SET_SECOND_REVIEW_RESULT_RECORDED';
export const APPLICATION_HUB_RESET_HAS_REIMBURSABLE_MEALS =
  'APPLICATION_HUB_RESET_HAS_REIMBURSABLE_MEALS';
export const APPLICATION_HUB_SET_HAS_REIMBURSABLE_MEALS =
  'APPLICATION_HUB_SET_HAS_REIMBURSABLE_MEALS';

export const APPLICATION_HUB_WRITE_REPROCESS_LOADING =
  'APPLICATION_HUB_WRITE_REPROCESS_LOADING';
export const APPLICATION_HUB_WRITE_REPROCESS_SUCCESS =
  'APPLICATION_HUB_WRITE_REPROCESS_SUCCESS';
export const APPLICATION_HUB_WRITE_REPROCESS_ERROR =
  'APPLICATION_HUB_WRITE_REPROCESS_ERROR';
export const APPLICATION_HUB_WRITE_REPROCESS_SAVE_SUCCESSFUL =
  'APPLICATION_HUB_WRITE_REPROCESS_SAVE_SUCCESSFUL';
export const APPLICATION_HUB_SET_IS_VERIFICATION =
  'APPLICATION_HUB_SET_IS_VERIFICATION';
export const APPLICATION_HUB_SET_IS_SELECTED_FOR_VERIFICATION =
  'APPLICATION_HUB_SET_IS_SELECTED_FOR_VERIFICATION';
export const APPLICATION_HUB_SET_VERIFICATION_SELECTION_LETTER_PRINTED =
  'APPLICATION_HUB_VERIFICATION_SELECTION_LETTER_PRINTED';



// WEBPACK FOOTER //
// ./src/pages/manageapplication/state/hub/types.js